import { FormHelperText } from '@dropbox/dig-components/form_row';
import { UIIcon } from '@dropbox/dig-icons';
import { FailLine } from '@dropbox/dig-icons/dist/mjs/assets/ui-icon/line/fail';
import React from 'react';

interface Props {
  message: string;
  id: string;
}

export function ValidationMessage({ message, id }: Props) {
  return (
    <FormHelperText variant="alert" id={id}>
      <UIIcon src={FailLine} size="small" aria-hidden="true" />
      <span>{message}</span>
    </FormHelperText>
  );
}
